import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Loader } from '@vivaahealth/design-system';

import * as store from '../../../reducers/store';
import * as api from '../../../api';

import { InfoMessage } from '../../../components/InfoMessage';
import { useDocumentImage } from '../../../hooks/document/useDocumentImage';

import styles from '../review.module.css';

interface PhotoIdProps {
  label: string;
  imageUrl?: string;
  pending?: string;
  error?: string;
}

export const PhotoId: React.FC<PhotoIdProps> = ({ label, imageUrl, error }) => {
  const { t } = useTranslation('review');

  if (error) return <InfoMessage isError={true}>{error}</InfoMessage>;
  if (imageUrl) {
    return (
      <img
        alt={t('identification')}
        src={imageUrl}
        className={styles.ImageStyle}
      />
    );
  }
  return (
    <div className={styles.LoaderWrapper}>
      <Loader variant="dot" color="gray" />
    </div>
  );
};

const PhotoIdContainer: React.FC<{
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}> = ({ field }) => {
  const { t } = useTranslation('review');
  const formSet = useSelector((store: store.Loaded) => {
    return store.formSets[field.previsitFormSetId];
  });
  if (!formSet?.encounter?.id) {
    throw new Error('Unable to find the associated encounter.');
  }
  const { url } = useDocumentImage(
    formSet.encounter.id,
    api.PatientUpload.DocumentType.PhotoID,
  );
  return <PhotoId label={t(_.camelCase(field.primitive))} imageUrl={url} />;
};

export default PhotoIdContainer;
